import image_404 from "../assets/404.jpg";

export default function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-white">
      <img src={image_404} alt="404 Animation" className="w-64 h-auto" />
      <h1 className="text-6xl font-bold text-gray-800 mt-4">404</h1>
      <p className="text-xl text-gray-600 mt-2">
        Oops! The page you're looking for doesn't exist.
      </p>
      {/* <a
        href="/"
        className="mt-6 px-6 py-3 bg-blue-600 text-white text-lg font-semibold rounded-lg shadow-md hover:bg-blue-700 transition no-underline"
      >
        Go Home
      </a> */}
    </div>
  );
}
